import React, {useRef, useState, useCallback } from 'react';
import {useParams, Link } from "react-router-dom";
import {getCity } from "../../services/userservice";
import {setTBoCitySyncHotel} from "../../services/userservice";
import "./AddCitySync.css";

const AddCitySync = () => {
  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [formData, setFormData] = useState({
    city_id: "",
    city: "",
    trip_city_id: ""
  });
  const [showDropdownFrom, setShowDropdownFrom] = useState(false);
  const [formDataCity, setFormDataCity] = useState(null);
  const [searchCity, setSearchCity] = useState('');
  const [flightList, setFlightList] = useState([]);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Debounce function for search
  const debounce = (func, delay) => {
    let debounceTimer;
    return function (...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func(...args), delay);
    };
  };

  const fetchCountryList = useCallback(
    debounce(async (term) => {
      if (term) {
        try {
          const data = await getCity(term);
          setFlightList(data);
        } catch (error) {
          console.error('Failed to fetch flight list', error);
        }
      }
    }, 500),
    []
  );

  // Update formDataCity when a city is selected
  const handleSelectFrom = (city) => {
    setError("");
    setSuccessMessage("");
    setFormData({
        city_id:city?.tboCityId,
        city:city?.cityName,
        trip_city_id: city?.tripjack_city_id
    });
    setShowDropdownFrom(false);
  };


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");
    try {
      const payload = { ...formData };
      const response = await setTBoCitySyncHotel(payload);
      setSuccessMessage(response?.data?.message)
    } catch (error) {
      setError(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">{isEditMode ? "Edit" : "Add"} city for syncing Tbo-Hotel</h1>
            </div>

            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  syncing Tbo-Hotel
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-body">
                    {error && (
                      <div className="alert alert-danger">{error}</div>
                    )}
                    {successMessage && (
                      <div className="alert alert-success">{successMessage}</div>
                    )}
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className='from-title cursor-pointer'>Select City</label>
                          <button
                            type="button" 
                            className='flight_from-search-btn'
                            aria-label="Select City"
                            onClick={() => setShowDropdownFrom(!showDropdownFrom)}
                          >
                            <span className='flight-select-title'>{formData?.city || "Select City"}</span>
                          </button>
                          {showDropdownFrom && (
                            <div ref={dropdownRef} className="search-list-container">
                              <input
                                placeholder="Search for City..."
                                ref={inputRef}
                                value={setFormData?.city_id}
                                onChange={(e) => {
                                  setSearchCity(e.target.value);
                                  fetchCountryList(e.target.value);
                                }}
                                style={{ height: "60px" }}
                              />
                              <ul className='search-list'>
                                {flightList?.data?.map((city, index) => (
                                  <li key={index} onClick={() => handleSelectFrom(city)} className="flight-item">
                                    <span className="city-name">{`${city.cityName}`} <span className='country-name'>({city.countryName})</span></span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddCitySync;
